import axios from "axios";
const serverUrl = process.env.REACT_APP_API_URL;

const api = {
    auth() {
        return {
            isAuthenticated: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/sessions/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            signIn: (userData) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(`${serverUrl}/sessions/`, userData, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            signInWithFirebase: (token) => {
                return axios.post(
                    `${serverUrl}/sessions/firebase/`,
                    { token },
                    { withCredentials: true }
                );
            },
            signOut: () =>
                new Promise((resolve, reject) => {
                    axios
                        .delete(`${serverUrl}/sessions/`, { withCredentials: true })
                        .then((res) => {
                            localStorage.removeItem("token");
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            getWorkspace: (id) =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/workspaces/${id}/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            channels: () => {
                return axios.get(`${serverUrl}/workspaces/current/channels/`, {
                    withCredentials: true,
                });
            },
            changeWorkspace: (workspaceId) => {
                return axios.put(
                    `${serverUrl}/sessions/`,
                    { workspaceId },
                    { withCredentials: true }
                );
            },
        };
    },
    chats() {
        return {
            list: (params) =>
                new Promise((resolve, reject) => {
                    const chatGroupsId = params.chatGroupsId || [];
                    const conversationLabelsId = params.conversationLabels || [];
                    const participatingAgentsId = params.participatingAgentsId || [];
                    delete params.chatGroupsId;
                    delete params.conversationlabels;
                    delete params.participatingAgentsId;
                    const groupedConversationTagsIds = params.groupedConversationTags;

                    const queryParams = new URLSearchParams({ ...params });

                    for (let i = 0; i < chatGroupsId.length; i++) {
                        queryParams.append("chatGroupsId", chatGroupsId[i]);
                    }

                    if (groupedConversationTagsIds) {
                        const groupedTagIdsStr = JSON.stringify(groupedConversationTagsIds);
                        queryParams.append("groupedChatLabels", groupedTagIdsStr);
                    } else {
                        for (let i = 0; i < conversationLabelsId.length; i++) {
                            queryParams.append("chatLabelsId", conversationLabelsId[i]);
                        }
                    }
                    for (let i = 0; i < participatingAgentsId.length; i++) {
                        queryParams.append("participatingAgentsId", participatingAgentsId[i]);
                    }
                    params.statuses?.forEach((s) => queryParams.append("status", s));
                    axios
                        .get(`${serverUrl}/chat/conversation/?${queryParams}`, {
                            withCredentials: true,
                        })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            getHistory: (page, uuid = null, chatId = null, unifiedHistory = null) =>
                new Promise((resolve, reject) => {
                    if (!chatId && !uuid) {
                        throw new Error("uuid and chatId can not be both null");
                    }
                    const queryParams = new URLSearchParams({
                        page: page,
                        amount: 20,
                        userUuid: uuid,
                        chatId: chatId,
                        unifiedHistory: unifiedHistory,
                        includeServerMessages: true,
                    });
                    axios
                        .get(`${serverUrl}/chat/history/?${queryParams}`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            updateChat: (id, data) =>
                new Promise((resolve, reject) => {
                    axios
                        .put(`${serverUrl}/chat/conversation/${id}/`, data, {
                            withCredentials: true,
                        })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            sendNewAnswer: (id, userUuid) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/chats/messages/processing/questions/${id}/`,
                            { userUuid: userUuid, questionId: id },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            close: (id) =>
                new Promise((resolve, reject) => {
                    axios
                        .put(
                            `${serverUrl}/chat/conversation/${id}/`,
                            { markSeen: true, markEnded: true },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            upload: (file) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(`${serverUrl}/workspaces/current/files/`, file, {
                            withCredentials: true,
                        })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            groups: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/chat/groups/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            getCounters: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/chats-counters/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            getAggregatedCounters: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/aggregated-chats-counters/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            sendNote: (payload) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(`${serverUrl}/chat/history/`, payload, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            startFromFbComment: (userUuid, text) => {
                const body = {
                    uuid: userUuid,
                    messageText: text,
                };
                return axios.post(`${serverUrl}/chats/facebook-messenger/`, body, {
                    withCredentials: true,
                });
            },
        };
    },
    outbound() {
        return {
            getWhatsappTemplates: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/whatsapp-templates/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            createAndSendCampaign: (payload) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/whatsapp-campaigns/customers/${payload.customer_id}/`,
                            payload,
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            /**
             *
             * @param {Object} payload
             * @param {number} payload.templateId
             * @param {Array<{existingId: number, file: {name: string, url: string, mimeType:string}}>} payload.customers
             * @returns
             */
            createAndSendCampaignBulk: (payload) => {
                // Phone and countryCode does not matter if existing id is present.
                const fixedCustomers = payload.customers.map((c) => {
                    return { ...c, phone: "nan", countryCode: "nan" };
                });
                const fixedPayload = {
                    ...payload,
                    customers: fixedCustomers,
                    whatsappCampaignType: "ONE_CUSTOMER",
                    sendAsync: false,
                };

                return axios.post(`${serverUrl}/whatsapp-campaigns/bulk/customers/`, fixedPayload, {
                    withCredentials: true,
                });
            },
            getConfigs: () =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/whatsapp-outbound-config/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
        };
    },
    customer() {
        return {
            list: (page, searchText, startDate, endDate, has_whatsapp_opt_in = true) =>
                new Promise((resolve, reject) => {
                    const objParams = {
                        page: page,
                        amount: 9,
                        sortBy: "LAST_ACTIVITY",
                    };
                    if (searchText) {
                        objParams.searchText = searchText;
                    }
                    if (startDate) {
                        objParams.startDate = startDate;
                    }
                    if (endDate) {
                        objParams.endDate = endDate;
                    }
                    if (has_whatsapp_opt_in) {
                        objParams.has_whatsapp_opt_in = has_whatsapp_opt_in;
                    }
                    const queryParams = new URLSearchParams(objParams);
                    axios
                        .get(`${serverUrl}/customers/?${queryParams}`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            createOptIn: (customer) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(`${serverUrl}/opt-ins/whatsapp/`, customer, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            update: (customer) =>
                new Promise((resolve, reject) => {
                    axios
                        .put(`${serverUrl}/customers/${customer.id}/`, customer, {
                            withCredentials: true,
                        })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            getCustomerFields: (customer) =>
                new Promise((resolve, reject) => {
                    axios
                        .get(`${serverUrl}/customers/fields/`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
        };
    },
    users() {
        return {
            get: (groups, page) =>
                new Promise((resolve, reject) => {
                    let params = new URLSearchParams();
                    groups = groups || [];
                    groups.forEach((group) => {
                        params.append("chatGroupsId", group.id);
                    });
                    if (page) {
                        params.append("page", page);
                    }
                    params.append("amount", 32);
                    axios
                        .get(`${serverUrl}/users/?${params}`, { withCredentials: true })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            createPushDevice: (agentId, body) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(`${serverUrl}/users/${agentId}/pushdevice/`, body, {
                            withCredentials: true,
                        })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            createFCMDevice: (agentId, token, deviceType) => {
                return axios.post(
                    `${serverUrl}/users/${agentId}/fcmdevice/`,
                    { token: token, deviceType: deviceType },
                    { withCredentials: true }
                );
            },
            deleteFCMDevice: (agentId, token) => {
                return axios.delete(`${serverUrl}/users/${agentId}/fcmdevice/${token}/`, {
                    withCredentials: true,
                });
            },
            updateAgentState: (agentId, agentStateType) => {
                return axios.put(
                    `${serverUrl}/agents/${agentId}/change-state/`,
                    { agentStateType },
                    { withCredentials: true }
                );
            },
        };
    },
    globalUser() {
        return {
            get: (userId) => {
                return axios.get(`${serverUrl}/globaluser/${userId}/`, { withCredentials: true });
            },
        };
    },
    reco() {
        return {
            get: (workspaceId, question, amt) =>
                new Promise((resolve, reject) => {
                    if (!amt) {
                        amt = 5;
                    }
                    axios
                        .post(
                            `${serverUrl}/workspaces/${workspaceId}/assistant/predict/top/`,
                            { question: question, amt: amt },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            like: (workspaceId, sourceId, query) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/workspaces/${workspaceId}/assistant/like/`,
                            { userQuery: query, sourceId: sourceId },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            dislike: (workspaceId, sourceId, query) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/workspaces/${workspaceId}/assistant/dislike/`,
                            { userQuery: query, sourceId: sourceId },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            predict: (workspaceId, question, ranking) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/workspaces/${workspaceId}/assistant/predict/`,
                            { question: question, ranking: ranking },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
            train: (workspaceId, question, answer) =>
                new Promise((resolve, reject) => {
                    axios
                        .post(
                            `${serverUrl}/workspaces/${workspaceId}/assistant/user/train/`,
                            { question: question, answer: answer },
                            { withCredentials: true }
                        )
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }),
        };
    },
    tags() {
        return {
            list: () => {
                return axios.get(`${serverUrl}/chat-labels/`, { withCredentials: true });
            },
            getConversationTags: (id) => {
                return axios.get(`${serverUrl}/chats-labeler/?chatId=${id}`, {
                    withCredentials: true,
                });
            },
            addTagToConversation: (tag) => {
                return axios.put(`${serverUrl}/chats-labeler/`, tag, { withCredentials: true });
            },
            deleteTagFromConversation: (chatId, chatLabelId) => {
                return axios.delete(
                    `${serverUrl}/chats-labeler/chats/${chatId}/chat-labels/${chatLabelId}/`,
                    { withCredentials: true }
                );
            },
            listWithoutGroup: () => {
                return axios.get(`${serverUrl}/chat-labels/`, {
                    withCredentials: true,
                    params: { withoutGroup: true },
                });
            },
        };
    },
    tagsGroups() {
        return {
            list: () => {
                return axios.get(`${serverUrl}/chat-label-groups/`, { withCredentials: true });
            },
            get: (id) => {
                return axios.get(`${serverUrl}/chat-label-groups/${id}/`, {
                    withCredentials: true,
                });
            },
        };
    },
};
export { api, serverUrl };
